import React from 'react';
import DashboardIcon from '@mui/icons-material/Dashboard';
import GroupsIcon from '@mui/icons-material/Groups';
import StarIcon from '@mui/icons-material/Star';
import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import ContactsIcon from '@mui/icons-material/Contacts';
import {NavItem, NavWrapper} from './styles';
import {useDashboardContext} from "../../../Dashboard";
import ChecklistIcon from '@mui/icons-material/Checklist';

const iconMap = {
    Dashboard: <DashboardIcon/>,
    Groups: <GroupsIcon/>,
    Star: <StarIcon/>,
    Support: <SupportAgentIcon/>,
    Contacts: <ContactsIcon/>,
    Posts: <ChecklistIcon/>
};

export default function BottomNav({activeTab, onChangeTab}) {
    const {BOTTOM_NAV_ITEMS} = useDashboardContext();


    return (
        <NavWrapper>
            {BOTTOM_NAV_ITEMS.map((item) => {
                return (
                    <NavItem
                        key={item.id}
                        color={activeTab === item.id ? '#d81b60' : '#757575'}
                        onClick={() => onChangeTab(item.id)}
                    >
                        {iconMap[item.iconName]}
                        <span>{item.label}</span>
                    </NavItem>
                );
            })}
        </NavWrapper>
    );
}
